import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import EmpresaDashboard from './pages/empresa/EmpresaDashboard';
import CommercialLandingPage from './pages/public/CommercialLandingPage';
import { BrandingProvider } from './context/BrandingContext';

const SistemaRoutes = () => (
    <Routes>
        <Route path="/" element={<Login />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="empresa" element={<EmpresaDashboard />} />
    </Routes>
);

const App = () => {
    return (
        <ChakraProvider>
            <BrandingProvider>
                <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                    <Routes>
                        <Route path="/" element={<CommercialLandingPage />} />
                        <Route path="sistema/*" element={<SistemaRoutes />} />
                        <Route path="/dashboard" element={<Navigate to="/sistema/dashboard" replace />} />
                        <Route path="/empresa" element={<Navigate to="/sistema/empresa" replace />} />
                        <Route path="*" element={<Navigate to="/sistema" replace />} />
                    </Routes>
                </Router>
            </BrandingProvider>
        </ChakraProvider>
    );
};

export default App;
